import api from "./axios";

// Public Contact Support form. Submits to the backend, which stores the
// message and fires a real-time notification to every staff user.
// payload: { name, email, message }
export const submitContactMessage = (payload) =>
  api.post("/api/contact/", payload);
